import React, { Component } from "react"
import { Form } from "react-bootstrap"
import MaskedInput from "react-maskedinput"

interface PhoneNumberMaskedInputProps {
  allowNotProvided?: boolean
  autoComplete?: string
  className?: string
  isInvalid?: boolean
  readOnly?: boolean
  disabled?: boolean
  intl11?:boolean
  size?: "sm" | "lg"
  value: string
  id?: string
  onChange: (value: string) => void
}

export default class PhoneNumberMaskedInput extends Component<PhoneNumberMaskedInputProps> {
  render() {
    let msk = "111-111-1111"
    if(this.props.intl11 ===  true){
      msk = "1-111-111-1111"
    }
    return <Form.Control type="text"
      {...this.props}
      as={MaskedInput}
      formatCharacters={{
        "n": { validate: (char: string) => /[\d|n|N]/.test(char) ? "N" : "" },
        "s": { validate: (char: string) => /[\d|/]/.test(char) ? "N" : "" },
        "p": { validate: (char: string) => /[\d|p|P]/.test(char) ? "P" : "" }
      }}
      mask={!this.props.allowNotProvided || /^\d+/.test(this.props.value) ? msk : "nsp"}
      onChange={(e) => this.props.onChange(e.target.value)} />
  }
}
